export default {"src":"https://cdn.jetlend.ru/_next/static/media/download--active.bfac5cb3.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};